export default __webpack_public_path__ + "static/media/kid_and_sheets_poc_1.6a0d2956.png";